import { useState } from "react";
import { X, Zap } from "lucide-react";
import { Link } from "react-router-dom";

const AnnouncementBar = ({ onDismiss }: { onDismiss?: () => void }) => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className="bg-primary/10 border-b border-primary/20 relative z-[60] h-10 flex items-center" id="announcement-bar">
      <div className="container flex items-center justify-center px-8">
        <Link to="/#booking" className="flex items-center gap-2 text-sm font-medium text-primary hover:text-primary/80 transition-colors">
          <Zap className="h-3.5 w-3.5" />
          <span>Book your Tesla today — Starting at $99/day</span>
        </Link>
        <button
          onClick={() => { setDismissed(true); onDismiss?.(); }}
          className="absolute right-4 text-muted-foreground hover:text-foreground transition-colors"
          aria-label="Dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default AnnouncementBar;
